<template>
  <div class="scene-section">
    <div class="title-wrap">
      <div class="scene-title">景区风光</div>
    </div>
    <div class="gallery-grid">
      <div
        v-for="item in sceneList"
        :key="item.id"
        class="gallery-item"
        :style="getGridStyle(item)"
        @click="previewImage = item.imageUrl || item.img"
      >
        <img :src="item.img || thumbImg" :alt="item.title">
        <div class="gallery-title">{{ item.title }}</div>
      </div>
    </div>
    <div v-if="previewImage" class="preview-overlay" @click="previewImage = null">
      <img :src="previewImage" alt="" class="preview-img">
      <span class="preview-close" @click.stop="previewImage = null">×</span>
    </div>
  </div>
</template>

<script>
import { getGallery } from '../api/index'
import thumbImg from '../assets/imgs/ceshi.png'

export default {
  name: 'SceneSection',
  data() {
    return {
      thumbImg,
      sceneList: [],
      previewImage: null,
    }
  },
  mounted() {
    this.fetchGallery()
  },
  methods: {
    async fetchGallery() {
      try {
        const res = await getGallery('zh')
        if (res.code === 200 && res.data) {
          this.sceneList = res.data.map(item => ({
            id: item.id,
            title: item.title,
            img: item.thumbnailUrl || item.imageUrl,
            imageUrl: item.imageUrl,
            gridRowStart: item.gridRowStart,
            gridRowSpan: item.gridRowSpan,
            gridColumnStart: item.gridColumnStart,
            gridColumnSpan: item.gridColumnSpan,
          }))
        }
      } catch (e) {
        console.error('获取景区风光失败:', e)
      }
    },
    getGridStyle(item) {
      const style = {}
      if (item.gridRowStart) style.gridRowStart = item.gridRowStart
      if (item.gridRowSpan) style.gridRow = `span ${item.gridRowSpan}`
      if (item.gridColumnStart) style.gridColumnStart = item.gridColumnStart
      if (item.gridColumnSpan) style.gridColumn = `span ${item.gridColumnSpan}`
      return style
    },
  },
}
</script>

<style scoped lang="less">
.scene-section{
  margin-top: 0.5rem;
  .title-wrap{
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
    .scene-title{
      display: inline-block;
      font-size: 0.27rem;
      color: #115DB2;
      border-bottom: 2px solid #115DB2;
      padding-bottom: 0.02rem;
      margin-bottom: -1px;
    }
  }
  .gallery-grid{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 3.125rem;
    grid-auto-flow: dense;
    gap: 0.1rem;
    .gallery-item{
      position: relative;
      overflow: hidden;
      cursor: pointer;
      border-radius: 4px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.3s;
      }
      &:hover img{ transform: scale(1.05); }
      .gallery-title{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 8px 16px;
        background: linear-gradient(transparent, rgba(0,0,0,0.8));
        color: #fff;
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .preview-overlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.85);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .preview-img{
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
    }
    .preview-close{
      position: absolute;
      top: 0.3rem;
      right: 0.5rem;
      font-size: 0.6rem;
      color: #fff;
      cursor: pointer;
      &:hover{ opacity: 0.7; }
    }
  }
}
</style>
